import React, { useContext, useState } from "react";
import Card from "~/components/parts/Card";
import Application from "./Application";
import Generate from "./Generate";
import Selection from "./Selection";
import { SubscriptionContext } from "..";

const ActionMenu = () => {
  const { pendingApplication, subscription = {} } =
    useContext(SubscriptionContext);

  const [action, setAction] = useState(pendingApplication ? "application" : "");

  const cardTitle =
    {
      ACTIVE: "Extend",
      EXPIRED: "Renew",
    }[subscription.status] ?? "Subscribe";

  return (
    <Card className="border-l-0" title={cardTitle}>
      <div className="flex flex-col gap-6">
        <Selection action={action} setAction={setAction} />
        {action === "generate" && <Generate />}
        {action === "application" && <Application />}
      </div>
    </Card>
  );
};

export default ActionMenu;
